// Shared by SyncStatusLine and DriveSyncSettingsCard so both Drive status lines
// word auto-synced subfolders identically.
const MAX_NEW_FOLDER_NAMES = 3;

export function describeNewFolders(paths: string[]): string | null {
  if (paths.length === 0) return null;
  const shown = paths.slice(0, MAX_NEW_FOLDER_NAMES);
  const hidden = paths.length - shown.length;
  return `${paths.length} new ${paths.length === 1 ? "folder" : "folders"} started syncing: ${shown.join(", ")}${hidden > 0 ? `, and ${hidden} more` : ""}`;
}
